module.exports = __webpack_public_path__ + "img/copy.31ef4945.svg";